import { ApiTask, TaskStatus } from '@/types/tasks';

/**
 * Map API task status to local TaskStatus
 * API uses 'in_progress' while local uses 'in-progress'
 */
export const mapApiStatusToTaskStatus = (apiStatus: ApiTask['status']): TaskStatus => {
	switch (apiStatus) {
		case 'pending':
			return 'pending';
		case 'in_progress':
			return 'in-progress';
		case 'completed':
			return 'completed';
		case 'failed':
			return 'failed';
		default:
			return 'failed'; // fallback
	}
};

/**
 * Check if API task status represents a pending task
 */
export const isApiTaskPending = (apiStatus: ApiTask['status']): boolean => {
	return apiStatus === TaskStatus.Pending;
};

/**
 * Check if API task status represents an in-progress task
 */
export const isApiTaskInProgress = (apiStatus: ApiTask['status']): boolean => {
	return apiStatus === 'in_progress';
};

export const isApiTaskFailed = (apiStatus: ApiTask['status']): boolean => {
	return apiStatus === TaskStatus.Failed;
};
